function setTitle() {
  const heading = document.querySelector('[data-page-heading]');
  const title = heading.innerHTML;
  document.title = title;
}

document.addEventListener('DOMContentLoaded', () => {
  setTitle();
});

function collectionFilterInit() {
  const filterGroups = document.querySelectorAll('[data-filter-group]');
  const mobileToggle = document.querySelector('[data-mobile-filter-toggle]');
  const collectionFilter = document.querySelector('[data-collection-filter]');

  if (filterGroups == null) {
    return;
  }

  filterGroups.forEach(filterGroup => {
    const moreToggleParent = filterGroup.querySelector('[data-filter-group-more-item]');
    const moreToggle = filterGroup.querySelector('[data-filter-group-more-toggle]');
    const moreItems = filterGroup.querySelectorAll('[data-filter-group-item-hidden]');
    const listToggle = filterGroup.querySelector('[data-filter-group-list-toggle]');
    const listWrap = filterGroup.querySelector('[data-filter-group-list]');

    if (moreToggle) {
      moreToggle.addEventListener('click', () => {
        moreItems.forEach(moreItem => {
          moreItem.classList.remove('hide');
        });
        moreToggleParent.classList.add('hide');
      });
    }

    if (listToggle) {
      listToggle.addEventListener('click', () => {
        listToggle.classList.toggle('closed');
        listWrap.classList.toggle('hide');
      });
    }
  });

  mobileToggle.addEventListener('click', () => {
    mobileToggle.classList.toggle('active');
    collectionFilter.classList.toggle('show');
  });
}


document.addEventListener('DOMContentLoaded', () => {
  collectionFilterInit();
});
